<div class="row">
  <div class="col-lg-12">
    <div class="container-fluid px-0 info-list has-info-icon channels-container">
      <ng-container *ngIf="!isFreemium">
        <div class="channel-cont-main">
          <ng-container *ngFor="let channel of showChannels; let i = index;">
            <div class="channel-cont text-center" [ngClass]="{hidden: channel.channelName === 'N/A'}">
              <img src="{{channel.imgSrc}}" (error)="imageLoadError($event)">
              <div class="channel-name">{{channel.channelName}}</div>
            </div>
          </ng-container>
        </div>
        <div class="pagination-cont">
          <app-paginator
            (updatePageClick)="updateChannels($event)"
            [limit]="limit"
            [totalItems]="totalItems"></app-paginator>
        </div>
      </ng-container>
      <ng-container *ngIf="isFreemium">
        <div class="value text-capitalize d-inline-block m-3">
          <div class="freemium-lock">
            <i class="fa fa-lock"></i>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
